import React from 'react';
import Articles from '../components/Articles';
import SectionTitle from '../components/SectionTitle';
import config from '../config';
import store from '../store';
 let sectionTitles;
class ArticlesContainer extends React.Component {
    constructor(props) {
        super(props);
        store.dispatch(this.props.fetchArticlesData(config.author));
            this.state = {
                currentSectionIndex: 0,
                currentSectionArticles: [],
                sectionTitles: [] 
            }
            this.activeSection = this.activeSection.bind(this);
            this.sort = this.sort.bind(this);
            this.forceUpdate()
    }
    componentWillMount(){
        if (this.props.articles.length>0){
             this.setState({
                currentSectionArticles: this.props.articles[0].sections[0].articles,
                 sectionTitles: this.props.articles[0].sections.map((section,index)=>{
                    return section.sectionTitle
                })
             });
        }
    }
    activeSection(index) {
        let selectedSection = this.props.articles[0].sections[index];
        this.setState({
            currentSectionIndex: index,
            currentSectionArticles: selectedSection.articles,
            enableSort: selectedSection.enableSort,
            sectionTitles:sectionTitles
        })
    }

    sort(field) {
        let articles = this.state.currentSectionArticles.slice();
        articles.sort((a, b) => a[field].localeCompare(b[field]));
        if (field === 'articleDate') {
            articles.reverse();
        }
        this.setState({
            currentSectionArticles: articles
        })
    }

    render() {
        let currentSectionArticles=this.state.currentSectionArticles;
        sectionTitles=this.state.sectionTitles;
        if (this.state.currentSectionArticles.length==0 && this.props.articles.length>0){
            currentSectionArticles=this.props.articles[0].sections[0].articles;
            sectionTitles = this.props.articles[0].sections.map((section,index)=>{
                    return section.sectionTitle
                });
        }
        return (
            <div>
                <div className="page-title bg-grey">
                    {this.props.articles.length ? <SectionTitle title={this.props.articles[0].pageTitle} />: null }
                </div>
                <div className="page-content">
                    {this.props.articles.length && this.state ? <Articles
                        articles={currentSectionArticles}
                        activeSection={this.activeSection}
                        activeSessionIndex={this.state.currentSectionIndex}
                        sectionTitles={sectionTitles}
                        enableSort={this.state.enableSort}
                        sort={this.sort}
                    />: null }
                </div>
            </div>

        )
    }
}

export default ArticlesContainer;


// WEBPACK FOOTER //
// ./src/containers/ArticlesContainer.js